import { render, staticRenderFns } from "./RegisterFormComponent.vue?vue&type=template&id=1c822868&scoped=true&"
import script from "./RegisterFormComponent.vue?vue&type=script&lang=js&"
export * from "./RegisterFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormComponent.vue?vue&type=style&index=0&id=1c822868&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c822868",
  null
  
)

export default component.exports